/**
 * @param {Date} date - A date to check the validity of
 */
export const isValidDate = (date) => Boolean(date && !isNaN(date));
//# sourceMappingURL=datetimeUtils.js.map